import { createContext, useContext, useState, ReactNode } from 'react';

export type MarketplaceType = 'kiosk' | 'boutique' | 'restaurant';

interface MarketplaceContextType {
  marketplaceType: MarketplaceType;
  setMarketplaceType: (type: MarketplaceType) => void;
}

const MarketplaceContext = createContext<MarketplaceContextType | undefined>(undefined);

export function MarketplaceProvider({ children }: { children: ReactNode }) {
  const [marketplaceType, setMarketplaceTypeState] = useState<MarketplaceType>(() => {
    // Récupérer depuis localStorage ou utiliser 'kiosk' par défaut
    if (typeof window !== 'undefined') {
      const saved = localStorage.getItem('marketplaceType') as MarketplaceType;
      if (saved && ['kiosk', 'boutique', 'restaurant'].includes(saved)) {
        return saved;
      }
    }
    return 'kiosk';
  });

  const setMarketplaceType = (type: MarketplaceType) => {
    setMarketplaceTypeState(type);
    if (typeof window !== 'undefined') {
      localStorage.setItem('marketplaceType', type);
    }
  };

  return (
    <MarketplaceContext.Provider value={{ marketplaceType, setMarketplaceType }}>
      {children}
    </MarketplaceContext.Provider>
  );
}

export function useMarketplace() {
  const context = useContext(MarketplaceContext);
  if (context === undefined) {
    throw new Error('useMarketplace must be used within a MarketplaceProvider');
  }
  return context;
}

